// Recovered compiled webpack factory 95516. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { V: () => n });
  let n = (t) => (e) => (e <= 0.5 ? t(2 * e) / 2 : (2 - t(2 * (1 - e))) / 2);
}
